import React , {useState,useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars ,faClose, faUser,faShoppingCart} from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import style from '../../Styles/Header/Header.module.css' 
import Enum from '../../Common/Enum/Enum';

const Header = ({ selectedItem, setSelectedItem ,totalOrder,setTotalOrder}) => {

    const orderItems = useSelector((state) => state.orderStorage.orderItems);
    const [nav,setNav] = useState (false);
    const [animate, setAnimate] = useState(false);


    const calculateGrandTotal = () => {
        if (!orderItems || orderItems.length === 0) return 0;
        return orderItems.reduce((total, item) => {
          return total + (item.quantity * item.price);
        }, 0);
      };
    
    const grandTotal = calculateGrandTotal();    

    useEffect(() => {
        if (totalOrder > 0) {
          setAnimate(true);
          const timer = setTimeout(() => setAnimate(false), 500);
          return () => clearTimeout(timer);
        }
      }, [totalOrder]);

    return (
        <header className = {style.navbar}>        
        <div className={style.tophead}> 

        <div className={style.logoSection}>            
            <NavLink to="/" onClick={() => {setSelectedItem(Enum.MENU); setNav(false);}}>
                <div className={style.logo}></div>
            </NavLink>
        </div>
        
        <nav className={style.mainNav}>
                    
                        <div className={style.shoppingCart} >
                            <ul>
                            <li> 
                                    <NavLink to="/" onClick={() => {setSelectedItem(Enum.PEDIDO);}}>
                                        {totalOrder > 0 && 
                                            <div className={`${style.totalorderCart} ${animate ? style.animate : ''}`}>
                                                <div className={style.totalOrderText}>{totalOrder}</div>            
                                            </div>}
                                        <FontAwesomeIcon icon={faShoppingCart} className={style.iconCart}  />                                        
                                    </NavLink>                    
                                </li> 
                            </ul>
                            <div className={style.grandTotal}>
                                <p translate="no" > Q.{grandTotal.toFixed(2)}</p>
                            </div>
                        </div>
                        <div className={style.navOptions}>
                        <ul className={ nav ? [style.menu,style.active].join(' ')  : [style.menu]}> 
                            
                            <li>
                                <NavLink to="/" onClick={() => {setSelectedItem(Enum.MENU); setNav(!nav);}} > Menu </NavLink>
                            </li>               
                            <li>
                                <NavLink to="/SignUp" onClick={() => {setSelectedItem(Enum.REGISTRAR); setNav(!nav);} }> Registrar </NavLink>
                            </li>
                            <li>
                                <NavLink to="/Login" onClick={() => {setSelectedItem(Enum.LOGIN); setNav(!nav);}} >  
                                    <FontAwesomeIcon icon={faUser} className={style.icon} style={{ height: "20px" ,width : "20px" }} />
                                </NavLink>
                            </li>  
                        </ul>   
                        </div>         
                    </nav>
                                    
                <div onClick={() =>  setNav(!nav) } className={style.mobile_btn} >
                    {nav 
                    ? <FontAwesomeIcon icon={faClose} style={{ height: "40px" ,width : "40px" }} /> 
                    : <FontAwesomeIcon icon={faBars}  style={{ height: "40px" ,width : "40px" }} /> }                 
                </div>
            </div>
        </header>
     )
}

export default Header